import { IonButton, IonContent, IonPage, IonSpinner } from '@ionic/react';
import React, { useContext } from 'react';
import { MessageContext } from '../contexts/MessageContext';
import LojaDiscovery from '../pages/Cliente/Home/pages/Inicio/LojaDiscovery';

export default function StoreAccessBoundary({ children }: { children: React.ReactNode }) {
  const { dadosEmpresa, storeAccess, storeLoading, storeError, selectMarketplaceStore, retryStore, clearActiveStore } = useContext(MessageContext);
  if (dadosEmpresa) return <>{children}</>;
  if (!storeLoading && !storeError && storeAccess.accessMode === 'marketplace' && !storeAccess.empresaid) {
    return <LojaDiscovery onSelectStore={selectMarketplaceStore} />;
  }
  return <IonPage className="Inicio inicio-page"><IonContent>
    <div className="store-discovery-state" role="status">
      {storeLoading ? <><IonSpinner name="crescent" /><p>Carregando loja...</p></> : <>
        <h2>Não foi possível abrir a loja</h2>
        <p>{storeError || 'Não foi possível identificar esta loja.'}</p>
        <IonButton onClick={retryStore}>Tentar novamente</IonButton>
        {storeAccess.accessMode === 'marketplace' && <IonButton fill="outline" onClick={clearActiveStore}>Escolher outra loja</IonButton>}
      </>}
    </div>
  </IonContent></IonPage>;
}
